import { render, staticRenderFns } from "./addMeterWater.vue?vue&type=template&id=5bf8bdac&scoped=true"
import script from "./addMeterWater.vue?vue&type=script&lang=js"
export * from "./addMeterWater.vue?vue&type=script&lang=js"
import style0 from "./addMeterWater.vue?vue&type=style&index=0&id=5bf8bdac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf8bdac",
  null
  
)

export default component.exports